export default "__VITE_ASSET__BmSQeGPJ__"